import { createFileRoute, redirect } from '@tanstack/react-router';

import { meQueryOptions } from '~/lib/auth';
import { departmentsQueryOptions } from '~/lib/departments';

const STORAGE_KEY = 'kiku:last-dept-slug';

export const Route = createFileRoute('/_authenticated/jobs/')({
  beforeLoad: async ({ context }) => {
    const [data, session] = await Promise.all([
      context.queryClient.fetchQuery(departmentsQueryOptions),
      context.queryClient.fetchQuery(meQueryOptions)
    ]);

    const departments = data.departments;
    const first = departments[0];
    if (!first) return;

    const stored = localStorage.getItem(STORAGE_KEY);
    const resolved = (stored ? departments.find((d) => d.slug === stored) : null) ?? first;

    localStorage.setItem(STORAGE_KEY, resolved.slug);

    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/org/$orgSlug/department/$deptSlug/jobs',
      params: { orgSlug: session.orgSlug, deptSlug: resolved.slug }
    });
  },
  component: () => null
});
